import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap'
import * as yup from 'yup'

// @hooks
import { useEncuesta } from 'hooks/useEncuesta'
import { useGrupoInteres } from 'hooks/useGrupoInteres'
import { useFormik } from 'formik'

const encuestaSchema = yup.object().shape({
  grupo_interes: yup.number().required('Este campo es requerido'),
  descripcion: yup.string().required('Este campo es requerido'),
  titulo: yup.string().required('Este campo es requerido'),
})

export const ModalCreditarEncuesta = ({encuesta, open, onToggle, onClosedModal }) => {
  /**
   * Consultas
   */
   const {
    obtenerGruposInteres,
  } = useGrupoInteres()
  const { data: gruposInteres } = obtenerGruposInteres('')
   const {
    handleActualizarEncuesta,
    handleCrearEncuesta,
  } = useEncuesta(onToggle)

   const { handleChange, values, handleSubmit, errors } = useFormik({
    enableReinitialize: true,
    validationSchema: encuestaSchema,
    initialValues: {
      ...encuesta,
      grupo_interes:
        encuesta?.grupo_interes?.id || '',
    },
    onSubmit: async (values, acciones) => {
      if (encuesta.id) {
        handleActualizarEncuesta({ values, acciones, id: encuesta.id })
      } else {
        handleCrearEncuesta(values, acciones)
      }
    },
  })
  
  return (
    <Modal
      isOpen={open}
      toggle={onToggle}
      size='lg'
      unmountOnClose
      onClosed={onClosedModal}
    >
      <ModalHeader toggle={onToggle}>
        {encuesta.id ? 'Editar' : 'Crear'} encuesta
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Grupo de Interés</Label>
                <Input
                  type='select'
                  name='grupo_interes'
                  value={values.grupo_interes}
                  onChange={handleChange}
                  placeholder='Ingrese grupo interés'
                  invalid={!!errors.grupo_interes}
                >
                  <option value={null}>Seleccione...</option>
                  {gruposInteres?.results?.map(({id, nombre}, key) => (
                    <option key={key} value={id}>{nombre}</option>
                  ))}
                </Input>
                <div className='invalid-feedback'>{errors.grupo_interes}</div>
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Título</Label>
                <Input
                  type='text'
                  name='titulo'
                  placeholder='Ingrese titulo'
                  value={values.titulo}
                  onChange={handleChange}
                  invalid={!!errors.titulo}
                />
                <div className='invalid-feedback'>{errors.titulo}</div>
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={8}>
              <FormGroup>
                <Label>Descripción</Label>
                <Input
                  type='textarea'
                  name='descripcion'
                  placeholder='Ingrese descripción'
                  value={values.descripcion}
                  onChange={handleChange}
                  invalid={!!errors.descripcion}
                />
                <div className='invalid-feedback'>{errors.descripcion}</div>
              </FormGroup>
            </Col>
          </Row>

          <Button color='primary' type='submit'>Guardar</Button>
        </form>
      </ModalBody>
    </Modal>
  )
}

ModalCreditarEncuesta.propTypes = {
  encuesta: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onClosedModal: PropTypes.func.isRequired,
}
